/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_OptionExercise_RecalculateOptionExercisesResponseDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_RecalculateOptionExercisesResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OptionExerciseRecalculationService {

    /**
     * @returns Wealthlane_AwardService_Dtos_OptionExercise_RecalculateOptionExercisesResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionExerciseRecalculationRecalculateOptionExercisesBackground(): CancelablePromise<Wealthlane_AwardService_Dtos_OptionExercise_RecalculateOptionExercisesResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-exercise-recalculation/recalculate-option-exercises-background',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
